import _ from 'lodash';
import Vue from 'vue';
import InvestigatorQuestionsApi from '../../../api/InvestigatorQuestionsApi';

const CASHFLOW_CATEGORIES = {
  fixed: 'fixed',
  variable: 'variable',
  excluded: 'excluded',
};

const state = {
  questions: [],
};

function _findQuestion(questions, transactionId) {
  return _.find(state.questions, q => q.transactionId === transactionId);
}

function _getOptimisticAction(questions, transactionId, cashflowCategory) {
  const question = _findQuestion(questions, transactionId);
  if (question.incomeAmount > 0) {
    if (cashflowCategory === CASHFLOW_CATEGORIES.fixed) {
      return 'moveVariableIncomeToFixed'; // return function itself
    } else if (cashflowCategory === CASHFLOW_CATEGORIES.excluded) {
      return 'excludeVariableIncome';
    }
  }
  if (cashflowCategory === CASHFLOW_CATEGORIES.fixed) {
    return 'moveVariableExpenseToFixed';
  } else if (cashflowCategory === CASHFLOW_CATEGORIES.excluded) {
    return 'excludeVariableExpense';
  }
  return null;
}

const getters = {
  CASHFLOW_CATEGORIES: () => CASHFLOW_CATEGORIES,
  hasUnansweredQuestions: state => !!_.find(state.questions, q => q.cardOpen),
  suggestedAnswers: () => {
    return { DEFAULT: 'default', SALARY: 'salary' };
  },
};

const actions = {
  async initCashflowCategory({ commit }) {
    const cashflowCategoryQuestions = await InvestigatorQuestionsApi.fetchBudgetCategoryQuestions();
    _.forEach(cashflowCategoryQuestions, q => _.merge(q, { cardOpen: true }));
    commit('setQuestions', cashflowCategoryQuestions);
  },
  async setCashflowCategory({ commit, getters, dispatch }, { isLatestCashflow, transactionId, cashflowCategory }) {
    try {
      if (isLatestCashflow) {
        const action = _getOptimisticAction(state.questions, transactionId, cashflowCategory);
        if (action) {
          dispatch('optimisticChange/appendAction', { action, actionArguments: { transactionId } }, { root: true });
        }
      }
      commit('setCashflowCategory', { cashflowCategory, cardOpen: false, transactionId });
      await InvestigatorQuestionsApi.answerTransactionCategoryQuestion({ transactionId, budgetCategory: cashflowCategory });
    } catch (e) {
      commit('setCashflowCategory', { cashflowCategory: '', cardOpen: true, transactionId });
    }
  },
  reopenQuestion({ commit, dispatch }, { transactionId }) {
    dispatch('optimisticChange/removeAction', { actionArguments: { transactionId } }, { root: true });
    commit('reopenQuestion', { transactionId });
  },
};

// mutations
const mutations = {
  setQuestions(state, cashflowCategoryQuestions) {
    state.questions = cashflowCategoryQuestions; // eslint-disable-line
  },
  setCashflowCategory(state, { cashflowCategory, transactionId, cardOpen }) {
    const question = _findQuestion(state.questions, transactionId);
    Vue.set(question, 'cardOpen', cardOpen);
    Vue.set(question, 'cashflowCategory', cashflowCategory);
  },
  reopenQuestion(state, { transactionId }) {
    const question = _findQuestion(state.questions, transactionId);
    Vue.set(question, 'cardOpen', true);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/cashflow-app/cashflowCategoryActions.js